module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer__help-buttons"
  }, [_c('app-button', {
    attrs: {
      "text": _vm.$t('footer.isThisLegal'),
      "action": _vm.isThisLegal
    }
  }), _vm._v(" "), (_vm.$store.getters.config('company_questions_signing') > 0) ? _c('app-button', {
    attrs: {
      "text": _vm.$t('footer.iHaveAQuestion'),
      "action": _vm.question
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('app-button', {
    attrs: {
      "text": _vm.$store.getters.footerNextButtonText(),
      "action": _vm.nextField,
      "classList": "button--cta float-right"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer__info float-right"
  }, [_vm._v(_vm._s(_vm.requiredItems))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd65d982","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1062
// module chunks = 1